class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Liebelei: Warenkorb-Symbol im Header (CP Header) oeffnet die Schublade statt der Warenkorbseite */
document.addEventListener('click', function (event) {
  const link = event.target.closest && event.target.closest('a[class*="header-cart-"]');
  if (!link) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  drawer.open(link);
});

/* Liebelei (20.10.26): Set-Button auf der Produktseite (Geschenkset / 3er-Set) legt ins Warenkorb-Schublade
   statt auf die Warenkorbseite weiterzuleiten. Laeuft in der Capture-Phase vor dem alten Skript der Produktseite.
   Ist keine Schublade vorhanden, bleibt das bisherige Verhalten (Weiterleitung) bestehen. */
document.addEventListener(
  'click',
  function (event) {
    var button = event.target.closest && event.target.closest('[data-trio-variant]');
    if (!button) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.stopPropagation();
    event.preventDefault();
    if (button.disabled) return;

    var variantId = Number(button.dataset.trioVariant);
    if (!variantId) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (state) {
        state.id = variantId;
        drawer.renderContents(state);
        button.disabled = false;
        button.textContent = originalText;
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Bitte erneut versuchen';
        setTimeout(function () {
          button.textContent = originalText;
        }, 3000);
      });
  },
  true
);

/* Liebelei (20.10.26): KI-Zusammenfassung der Judge.me-Bewertungen ausblenden.
   Die Klassennamen von Judge.me sind nicht bekannt, deshalb wird der Block
   ueber den Text "KI-generiert" gefunden (das Widget wird erst spaet geladen).
   Sucht im ganzen Dokument und auch in Shadow-DOM-Bereichen.
   (21.10.26) Das Bild-Label der Hero-Sektionen ("KI-generiert", Klasse hero-ki-label-*) wird ausgenommen,
   sonst wurden ganze Produkttext-/Rezept-Sektionen mit ausgeblendet. */
(function () {
  var LABEL = /KI-generiert|AI-generated|AI generated/i;
  var CAROUSEL = '[class*="jdgm-carousel"], [class*="carousel"]';
  function hasCarousel(el) {
    return !!(el.matches && el.matches(CAROUSEL)) || !!(el.querySelector && el.querySelector(CAROUSEL));
  }
  function collect(root, out) {
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.shadowRoot) collect(el.shadowRoot, out);
      if (el.closest && el.closest('[class*="hero-ki-label"]')) continue;
      if (el.children.length === 0 && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE') {
        var t = el.textContent || '';
        if (t.length < 80 && LABEL.test(t)) out.push(el);
      }
    }
  }
  function hideBlock(label) {
    var node = label;
    while (true) {
      var parent = node.parentElement;
      if (!parent) {
        var rootNode = node.getRootNode && node.getRootNode();
        if (rootNode && rootNode.host && !hasCarousel(rootNode.host)) node = rootNode.host;
        break;
      }
      if (hasCarousel(parent) || /^(MAIN|BODY|HTML)$/.test(parent.tagName) || (parent.classList && parent.classList.contains('shopify-section'))) break;
      node = parent;
    }
    node.style.setProperty('display', 'none', 'important');
    if (node === label) {
      var prev = label.previousElementSibling;
      var guard = 0;
      while (prev && guard < 3 && !hasCarousel(prev)) {
        prev.style.setProperty('display', 'none', 'important');
        if (/Was Kunden/i.test(prev.textContent || '')) break;
        prev = prev.previousElementSibling;
        guard++;
      }
    }
  }
  function hideAiSummary() {
    var labels = [];
    collect(document, labels);
    labels.forEach(hideBlock);
  }
  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(hideAiSummary, 150);
  }
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
